import { render, staticRenderFns } from "./PeopleRolesGrid.vue?vue&type=template&id=b09a1b6e&"
import script from "./PeopleRolesGrid.vue?vue&type=script&lang=js&"
export * from "./PeopleRolesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports